module.exports = __webpack_public_path__ + "static/media/bogdan_knezevic.02301794.png";